@if (embedded) {
  <div class="embed">
    <div class="embed-accent"></div>

    <header class="embed-header no-print">
      <span class="flex items-center min-w-0">
        @if (mandate()?.merchantLogoUrl) {
          <img [src]="mandate()!.merchantLogoUrl" [alt]="mandate()?.merchantName || 'Comercio'" class="h-7 w-auto max-w-[140px] object-contain" />
        } @else if (mandate()?.merchantName) {
          <span class="text-[22px] font-bold tracking-[-0.03em] truncate">{{ mandate()?.merchantName }}</span>
        } @else {
          <img src="assets/images/pento-icon.png" alt="Pento" class="h-6 w-auto" />
        }
      </span>
      <span class="inline-flex flex-none gap-1.5 items-center text-xs text-[#4B5563]">
        <i class="pi pi-lock text-xs" aria-hidden="true"></i>
        Pago seguro · Pento
      </span>
    </header>

    @switch (view()) {
      @case ('loading') {
        <main class="embed-main items-center justify-center">
          <div class="inline-block animate-spin rounded-full h-10 w-10 border-2 border-slate-300 border-t-slate-700"></div>
        </main>
      }

      @case ('invalid') {
        <main class="embed-main justify-center px-6 py-10 text-center">
          <h1 class="serif text-[22px] font-bold m-0">Liga inválida o vencida</h1>
          <p class="mt-3 mb-0 text-[15px] text-[#374151]">Pide al comercio que te envíe una nueva liga.</p>
        </main>
      }

      @case ('unavailable') {
        <main class="embed-main justify-center px-6 py-10 text-center">
          <h1 class="serif text-[22px] font-bold m-0">Esta liga ya no admite registrar una tarjeta</h1>
          <p class="mt-3 mb-0 text-[15px] text-[#374151]">Estado del mandato: <strong>{{ statusLabel() }}</strong></p>
        </main>
      }

      @case ('review') {
        <main class="embed-main justify-center px-6 py-10 text-center">
          <h1 class="serif text-[22px] font-bold m-0">Estamos confirmando tu pago, no lo intentes de nuevo</h1>
          <p class="mt-3 mb-0 text-[15px] text-[#374151]">Te avisaremos por correo en cuanto tengamos la respuesta del banco.</p>
        </main>
      }

      @case ('form') {
        @if (mandate(); as m) {
          <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col flex-1 min-h-0">
            <main class="embed-main">
              <section class="px-4 pt-5 pb-4">
                <h1 class="m-0 text-sm font-medium text-[#374151]">
                  {{ isVerification() ? 'Cargo de validación' : (m.enrollmentChargeConcept || m.purpose) }} · hoy
                </h1>
                <p class="mt-1 mb-0 mono text-[34px] leading-[1.15] font-semibold">
                  {{ m.enrollmentChargeAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                  <span class="text-[15px] font-medium text-[#4B5563]">{{ m.currencyCode || 'MXN' }}</span>
                </p>
                @if (isVerification()) {
                  <p class="mt-1.5 mb-0 text-[13px] leading-normal text-[#4B5563]">Se cancela de inmediato; podrías ver una retención temporal en tu estado de cuenta.</p>
                } @else if (m.enrollmentChargeLines?.length) {
                  <ul class="mt-1.5 mb-0 pl-4 text-[13px] leading-normal text-[#4B5563]">
                    @for (line of m.enrollmentChargeLines; track $index) {
                      <li>
                        {{ line.quantity }} × {{ line.description }} · {{ (line.totalAmount ?? line.unitPrice) | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                        @if (line.taxAmount) {
                          (incluye impuestos por {{ line.taxAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }})
                        }
                      </li>
                    }
                  </ul>
                }
                <p class="mt-2.5 mb-0 text-sm leading-normal text-[#374151]">
                  @if (isReplacement()) {
                    Esta tarjeta sustituirá a la terminada en <strong class="mono text-[#1B2333]">{{ m.currentCardLastDigits }}</strong>.
                  }
                </p>
                @if (holderIncomplete()) {
                  <p class="field-error mt-2.5">Faltan datos obligatorios del titular (nombre, apellido paterno o correo); no es posible firmar este mandato.</p>
                }
              </section>

              <section class="flex-none border-y border-[#E5E7EB]">
                <h2 class="m-0 text-sm font-semibold">
                  <button type="button" class="embed-toggle" [attr.aria-expanded]="detailOpen()" aria-controls="detalle-mandato"
                    (click)="detailOpen.set(!detailOpen())">
                    <span>Ver detalle del mandato</span>
                    <i class="pi pi-chevron-down text-sm flex-none transition-transform" [class.rotate-180]="detailOpen()" aria-hidden="true"></i>
                  </button>
                </h2>
                @if (detailOpen()) {
                  <div id="detalle-mandato" class="px-4 pt-1 pb-5 flex flex-col gap-5">
                    <dl class="embed-dl">
                      <dt>Folio</dt>
                      <dd class="mono font-semibold">{{ m.number }}</dd>
                      <dt>Emisión</dt>
                      <dd>{{ (m.issuedAt || today) | date:'dd/MM/yyyy' }}</dd>
                      <dt>Beneficiario</dt>
                      <dd>
                        <strong>{{ m.merchantLegalName || m.merchantName }}</strong>
                        @if (m.merchantTaxId) { <br />RFC {{ m.merchantTaxId }} }
                        @if (m.merchantAddress) { <br />{{ m.merchantAddress }} }
                      </dd>
                      <dt>Titular</dt>
                      <dd>
                        <strong>{{ holderName() || '—' }}</strong>
                        <br /><span class="normal-case">{{ form.controls.customerEmail.value || '—' }}</span>
                        @if (form.controls.customerPhone.value) { <br /><span class="mono">{{ form.controls.customerPhone.value }}</span> }
                      </dd>
                      <dt>Concepto</dt>
                      <dd>{{ m.purpose }}</dd>
                      @for (row of limitRows(); track row.key) {
                        <dt>{{ row.label }}</dt>
                        <dd>{{ limitValue(row) }}</dd>
                      }
                      <dt>Vigencia</dt>
                      <dd>
                        Desde el {{ (m.validFrom || today) | date:'dd/MM/yyyy' }},
                        @if (m.validUntil) {
                          hasta el {{ m.validUntil | date:'dd/MM/yyyy' }} o su revocación
                        } @else {
                          hasta su revocación
                        }
                      </dd>
                      <dt>Liga vence</dt>
                      <dd>{{ m.enrollmentExpiresAt | date:"dd/MM/yyyy 'a las' HH:mm" }}</dd>
                    </dl>

                    @if (clauses().length) {
                      <div>
                        <h3 class="serif m-0 mb-2.5 text-base font-semibold">Cláusulas</h3>
                        <ol class="serif m-0 pl-5 flex flex-col gap-2.5 text-[15px] leading-normal text-[#1F2937] list-decimal">
                          @for (clause of clauses(); track $index) {
                            <li>
                              {{ clause.text }}
                              @if (clause.items.length) {
                                <ul class="mt-1.5 mb-0 pl-5 list-disc">
                                  @for (item of clause.items; track $index) {
                                    <li>{{ item }}</li>
                                  }
                                </ul>
                              }
                            </li>
                          }
                        </ol>
                      </div>
                    }

                    <p class="m-0 text-[13px] leading-normal text-[#4B5563]">
                      ¿Algún dato es incorrecto? <span class="underline">Solicita a {{ m.merchantName }} un nuevo mandato</span>.
                    </p>
                  </div>
                }
              </section>

              <section class="flex-none p-4 flex flex-col gap-3">
                <fieldset id="mit-saved-cards" class="m-0 p-0 border-0 min-w-0 flex flex-col gap-2" [class.embed-cards-alert]="cardLimitReached()">
                  <legend class="p-0 mb-2 text-sm font-semibold">Tarjeta</legend>
                  @for (card of savedCards(); track card.id) {
                    <div class="embed-option" [class.is-selected]="selectedCardId() === card.id">
                      <label class="flex flex-1 min-w-0 gap-3 items-center self-stretch" [class.cursor-pointer]="card.selectable"
                        [class.opacity-60]="!card.selectable">
                        <input type="radio" class="embed-radio" name="mitSavedCard" [value]="card.id" [checked]="selectedCardId() === card.id"
                          [disabled]="!card.selectable || sending()" (change)="selectCard(card)" />
                        <span class="flex-1 min-w-0">
                          <span class="block text-[15px] font-medium">{{ card.brand || 'Tarjeta' }} <span class="mono">•••• {{ card.lastDigits }}</span></span>
                          <span class="block mt-0.5 text-[13px] text-[#4B5563]">
                            Vence {{ card.expirationMonth }}/{{ card.expirationYear }}
                            @if (card.inUse) { · {{ card.currentForMandate ? 'En uso en este mandato' : 'En uso' }} }
                          </span>
                        </span>
                      </label>
                      @if (!card.inUse) {
                        <button type="button" class="embed-link" [disabled]="deletingCardId() != null" (click)="openDeleteCard(card)">Eliminar</button>
                      }
                    </div>
                  }
                  @if (hasSelectableCards()) {
                    <label class="embed-option cursor-pointer text-[15px] font-medium" [class.is-selected]="selectedCardId() == null">
                      <input type="radio" class="embed-radio" name="mitSavedCard" [checked]="selectedCardId() == null" [disabled]="sending()"
                        (change)="selectCard(null)" />
                      Usar otra tarjeta
                    </label>
                  }
                </fieldset>

                @if (!selectedCard()) {
                  <label class="embed-field">Número de tarjeta
                    <input type="text" class="embed-input tracking-[0.04em]" formControlName="cardNumber" inputmode="numeric" maxlength="19"
                      autocomplete="cc-number" (input)="onDigits('cardNumber', 19)" placeholder="0000 0000 0000 0000"
                      [class.is-invalid]="invalid('cardNumber')" />
                    @if (invalid('cardNumber')) { <span class="field-error">Ingresa un número de tarjeta válido.</span> }
                  </label>
                  <div class="grid grid-cols-2 gap-3">
                    <label class="embed-field min-w-0">Vencimiento
                      <input #expiry type="text" class="embed-input" inputmode="numeric" maxlength="5" autocomplete="cc-exp" placeholder="MM/AA"
                        [value]="expiryValue()" (input)="onExpiry(expiry)" (blur)="touchExpiry()"
                        [class.is-invalid]="invalid('expMonth') || invalid('expYear') || cardExpired()" />
                    </label>
                    <label class="embed-field min-w-0">CVV
                      <input type="password" class="embed-input" formControlName="cvv" inputmode="numeric" maxlength="4" autocomplete="cc-csc"
                        (input)="onDigits('cvv', 4)" placeholder="•••" [class.is-invalid]="invalid('cvv')" />
                    </label>
                  </div>
                  @if (invalid('expMonth') || invalid('expYear') || invalid('cvv')) {
                    <p class="field-error">Revisa la vigencia (MM / AA) y el CVV (3 o 4 dígitos).</p>
                  } @else if (cardExpired()) {
                    <p class="field-error">La tarjeta está vencida. Usa una tarjeta vigente.</p>
                  }
                }
                <p class="m-0 text-xs leading-normal text-[#4B5563] flex gap-1.5 items-center">
                  <i class="pi pi-shield text-xs" aria-hidden="true"></i>
                  Los datos de la tarjeta se guardan cifrados con el procesador de pagos; {{ m.merchantName }} no los ve.
                </p>
              </section>
            </main>

            <footer class="embed-footer">
              @if (error()) {
                <div class="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-[13px] leading-snug text-red-800" role="alert">
                  {{ error() }}
                  @if (attemptsExhausted()) {
                    <span class="block mt-1">Se agotaron los intentos. Pide al comercio una nueva liga.</span>
                  } @else if (result()?.remainingAttempts != null) {
                    <span class="block mt-1">Puedes intentar con otra tarjeta ({{ result()?.remainingAttempts }} intento(s) restante(s)).</span>
                  }
                </div>
              }
              <button type="submit" class="embed-btn" [disabled]="!canSign()">
                @if (sending()) {
                  <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Procesando…
                } @else {
                  @if (isVerification()) {
                    Autorizar cargo
                  } @else {
                    Autorizar cargo de {{ m.enrollmentChargeAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                  }
                }
              </button>
            </footer>
          </form>
        }
      }

      @case ('receipt') {
        @if (mandate(); as m) {
          <main class="embed-main">
            @if (signedEmail()) {
              <div class="no-print flex gap-3 items-start px-4 py-3 bg-[#ECFDF5] border-b border-[#A7F3D0]">
                <i class="pi pi-check-circle text-xl text-[#047857] mt-0.5" aria-hidden="true"></i>
                <div class="min-w-0 text-sm text-[#065F46]">
                  <p class="m-0 font-semibold">{{ isReplacement() ? 'Tarjeta reemplazada' : 'Mandato firmado' }}</p>
                  @if (result()?.message) { <p class="mt-0.5 mb-0">{{ result()?.message }}</p> }
                  <p class="mt-0.5 mb-0">Enviamos una copia a <span class="normal-case">{{ signedEmail() }}</span> con la liga para revocarlo.</p>
                </div>
              </div>
            }

            <section class="px-4 pt-5 pb-4 flex gap-4 justify-between items-start">
              <div class="min-w-0">
                <p class="eyebrow mb-1">Comprobante</p>
                <h1 class="serif text-[20px] leading-tight font-bold m-0">Mandato de cargo recurrente a tarjeta</h1>
              </div>
              <div class="stamp flex-none !px-3 !py-1.5" [class]="'stamp stamp-' + stamp().tone">
                <p class="m-0 text-sm font-bold tracking-[0.14em]">{{ stamp().label }}</p>
                @if (m.signature?.signedAt) {
                  <p class="mt-0.5 mb-0 mono text-[11px]">{{ m.signature?.signedAt | date:'dd/MM/yyyy HH:mm' }}</p>
                }
              </div>
            </section>

            <section class="px-4 pb-5 border-b border-[#E5E7EB]">
              <dl class="embed-dl">
                <dt>Folio</dt>
                <dd class="mono font-semibold">{{ m.number }}</dd>
                <dt>Beneficiario</dt>
                <dd>
                  <strong>{{ m.merchantLegalName || m.merchantName }}</strong>
                  @if (m.merchantTaxId) { <br />RFC {{ m.merchantTaxId }} }
                </dd>
                <dt>Titular</dt>
                <dd><strong>{{ m.signature?.signerName || m.customerLegalName || m.customerName }}</strong></dd>
                <dt>Tarjeta</dt>
                <dd class="mono font-semibold">•••• {{ m.signature?.cardLastDigits || m.currentCardLastDigits }}</dd>
                <dt>Concepto</dt>
                <dd>{{ m.purpose }}</dd>
                <dt>Límites</dt>
                <dd class="mono">
                  {{ maxPerCharge() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} / cobro ·
                  {{ maxPerMonth() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} / mes
                </dd>
                <dt>Vigencia</dt>
                <dd>Desde {{ m.validFrom | date:'dd/MM/yyyy' }}, {{ m.validUntil ? 'hasta el ' + (m.validUntil | date:'dd/MM/yyyy') : 'hasta su revocación' }}</dd>
              </dl>
            </section>

            <section class="px-4 py-5 border-b border-[#E5E7EB]">
              <h2 class="m-0 mb-3 text-sm font-semibold">Cargos bajo este mandato</h2>
              <div class="border-t border-[#E5E7EB]">
                @for (charge of receiptCharges(); track $index) {
                  <div class="flex gap-4 justify-between items-center py-3 border-b border-[#E5E7EB]">
                    <div class="min-w-0">
                      <p class="m-0 text-sm font-semibold">{{ charge.concept }}{{ charge.initial ? (charge.type === 'CARD_VERIFICATION' ? ' · cargo de validación' : ' · primer cobro') : '' }}</p>
                      <p class="mt-0.5 mb-0 text-xs text-[#4B5563]">
                        {{ charge.chargedAt | date:'dd/MM/yyyy' }}@if (charge.reference) { · Autorización {{ charge.reference }} }
                        @if (charge.type === 'CARD_VERIFICATION') {
                          · {{ charge.status === 'VOIDED' ? 'Cancelado' : 'Cancelación en proceso' }}
                        }
                      </p>
                    </div>
                    <p class="m-0 mono text-base font-semibold flex-none">{{ charge.amount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}</p>
                  </div>
                } @empty {
                  <p class="py-3 m-0 text-sm text-[#4B5563] border-b border-[#E5E7EB]">Aún no hay cargos con este mandato.</p>
                }
              </div>
              @if (m.status === 'ACTIVE' || m.status === 'SUSPENDED') {
                <p class="mt-3 mb-0 text-[13px] text-[#4B5563]">
                  Disponible este mes:
                  <strong class="mono text-[#1B2333]">{{ monthAvailable() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}</strong>
                  de {{ maxPerMonth() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                </p>
              }
            </section>

            <section class="px-4 py-5 flex flex-col gap-4">
              <div>
                <div class="script signature-box h-16 flex items-end px-2 pb-1.5 leading-none text-[#1E3A8A]">
                  <span class="signature-text" [appFitText]="m.signature?.signerName">{{ m.signature?.signerName || ' ' }}</span>
                </div>
                <div class="signature-line">
                  Firma electrónica · {{ m.signature?.signedAt | date:'dd/MM/yyyy HH:mm' }}@if (m.signature?.ipAddress) { · IP {{ m.signature?.ipAddress }} }
                </div>
              </div>
              <button type="button" class="btn-secondary btn-dark no-print w-full justify-center" (click)="print()">
                <i class="pi pi-download" aria-hidden="true"></i> Descargar PDF
              </button>
              @if (m.status === 'ACTIVE' || m.status === 'SUSPENDED') {
                <p class="no-print m-0 text-xs text-[#4B5563]">
                  Para revocar el mandato o administrar tus tarjetas usa la liga de gestión que te enviamos por correo.
                </p>
              }
              <p class="m-0 text-xs text-[#4B5563] break-all">
                Mandato {{ m.number }}@if (m.signature?.documentHash) { · Huella del documento <span class="mono">{{ m.signature?.documentHash }}</span> }
              </p>
            </section>
          </main>
        }
      }
    }
  </div>
} @else {
  <header class="topbar no-print">
    <div class="wrap flex items-center justify-between gap-3 py-3 sm:py-4">
      <div class="flex items-center gap-2.5 min-w-0">
        @if (mandate()?.merchantLogoUrl) {
          <img [src]="mandate()!.merchantLogoUrl" [alt]="mandate()?.merchantName || 'Comercio'" class="h-8 w-auto max-w-[160px] object-contain" />
        } @else if (mandate()?.merchantName) {
          <span class="text-xl sm:text-[26px] font-bold tracking-tight truncate">{{ mandate()?.merchantName }}</span>
        } @else {
          <img src="assets/images/pento-icon.png" alt="Pento" class="h-7 w-auto" />
        }
        <span class="hidden sm:block w-px h-5 bg-[#D7DCE3]"></span>
        <span class="hidden sm:inline text-[13px] text-[#4B5563]">Autorización de cobros</span>
      </div>
      <div class="flex flex-none items-center gap-2 text-[13px] text-[#4B5563]">
        <i class="pi pi-lock text-sm" aria-hidden="true"></i>
        <span class="hidden sm:inline">Conexión cifrada · Procesado por Pento</span>
        <span class="sr-only sm:hidden">Conexión cifrada, procesado por Pento</span>
      </div>
    </div>
  </header>

  <main class="wrap page">
    @switch (view()) {
      @case ('loading') {
        <div class="flex items-center justify-center min-h-[50vh]">
          <div class="inline-block animate-spin rounded-full h-10 w-10 border-2 border-slate-300 border-t-slate-700"></div>
        </div>
      }

      @case ('invalid') {
        <article class="doc max-w-xl mx-auto">
          <div class="doc-accent"></div>
          <div class="doc-pad text-center">
            <p class="eyebrow mb-2">Documento de autorización</p>
            <h1 class="serif text-[26px] font-bold m-0">Liga inválida o vencida</h1>
            <p class="text-[15px] text-[#374151] mt-3 mb-0">Pide al comercio que te envíe una nueva liga.</p>
          </div>
        </article>
      }

      @case ('unavailable') {
        <article class="doc max-w-xl mx-auto">
          <div class="doc-accent"></div>
          <div class="doc-pad text-center">
            <p class="eyebrow mb-2">Documento de autorización</p>
            <h1 class="serif text-[26px] font-bold m-0">Esta liga ya no admite registrar una tarjeta</h1>
            <p class="text-[15px] text-[#374151] mt-3 mb-0">Estado del mandato: <strong>{{ statusLabel() }}</strong></p>
          </div>
        </article>
      }

      @case ('review') {
        <article class="doc max-w-xl mx-auto">
          <div class="doc-accent"></div>
          <div class="doc-pad text-center">
            <p class="eyebrow mb-2">Documento de autorización</p>
            <h1 class="serif text-[26px] font-bold m-0">Estamos confirmando tu pago, no lo intentes de nuevo</h1>
            <p class="text-[15px] text-[#374151] mt-3 mb-0">Te avisaremos por correo en cuanto tengamos la respuesta del banco.</p>
          </div>
        </article>
      }

      <!-- ============================== FIRMA ============================== -->
      @case ('form') {
        @if (mandate(); as m) {
          <div class="flex flex-wrap items-center justify-between gap-x-6 gap-y-2 mb-4 text-[13px] text-[#4B5563]">
            <span class="hidden sm:inline">Paso 1 de 1 · Revisa, completa y firma</span>
            <span>Esta liga vence el <strong class="text-[#1B2333]">{{ m.enrollmentExpiresAt | date:"dd/MM/yyyy 'a las' HH:mm" }}</strong></span>
          </div>

          <form [formGroup]="form" (ngSubmit)="submit()">
            <article class="doc">
              <div class="doc-accent"></div>

              <div class="doc-head doc-pad sm:!pt-10 flex flex-wrap gap-5 sm:gap-6 justify-between items-start">
                <div class="flex-[1_1_380px] min-w-0">
                  <p class="eyebrow mb-2">Documento de autorización</p>
                  <h1 class="serif text-[24px] sm:text-[36px] leading-[1.15] font-bold m-0">
                    {{ isReplacement() ? 'Reemplazo de tarjeta del mandato de cargo a tarjeta' : 'Mandato de cargo recurrente a tarjeta' }}
                  </h1>
                  <p class="mt-3 mb-0 text-sm sm:text-[15px] leading-[1.55] text-[#374151] max-w-[520px]">
                    @if (isReplacement()) {
                      Por medio de este documento, el titular registra una nueva tarjeta que sustituye a la terminada en
                      <strong>{{ m.currentCardLastDigits }}</strong> para los cargos que realiza {{ m.merchantName }}.
                    } @else {
                      Por medio de este mandato, el titular autoriza a {{ m.merchantName }} a realizar cargos a su tarjeta dentro de los
                      límites y condiciones que se describen a continuación.
                    }
                  </p>
                </div>
                <dl class="m-0 flex-[1_1_100%] sm:flex-[0_1_240px] grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-[13px] border border-[#D7DCE3] rounded p-4">
                  <dt class="text-[#4B5563]">Folio</dt>
                  <dd class="m-0 mono font-semibold text-right">{{ m.number }}</dd>
                  <dt class="text-[#4B5563]">Emisión</dt>
                  <dd class="m-0 mono text-right">{{ (m.issuedAt || today) | date:'dd/MM/yyyy' }}</dd>
                  <dt class="text-[#4B5563]">Moneda</dt>
                  <dd class="m-0 mono text-right">{{ m.currencyCode || 'MXN' }}</dd>
                  <dt class="text-[#4B5563]">Estado</dt>
                  <dd class="m-0 text-right"><span class="pill pill-amber">{{ isReplacement() ? 'Reemplazo pendiente' : 'Sin firma' }}</span></dd>
                </dl>
              </div>

              <!-- 01 Las partes -->
              <section class="doc-section doc-pad">
                <h2 class="section-title"><span class="section-num">01</span>Las partes</h2>
                <div class="flex flex-wrap gap-6">
                  <div class="flex-[1_1_300px] min-w-0 bg-[#F6F7F9] rounded p-5">
                    <p class="label-caps mb-1.5">Beneficiario (acreedor)</p>
                    <p class="m-0 text-lg font-bold">{{ m.merchantLegalName || m.merchantName }}</p>
                    @if (m.merchantTaxId || m.merchantAddress) {
                      <p class="mt-1.5 mb-0 text-sm leading-normal text-[#374151]">
                        @if (m.merchantTaxId) { RFC {{ m.merchantTaxId }}<br /> }
                        {{ m.merchantAddress }}
                      </p>
                    }
                    <p class="mt-3 mb-0 text-[13px] text-[#4B5563]">Cobros procesados por Pento</p>
                  </div>
                  <div class="flex-[1.4_1_360px] min-w-0">
                    <p class="label-caps mb-3">Titular de la tarjeta (deudor)</p>
                    <div class="border border-[#D7DCE3] rounded p-5">
                      <p class="m-0 text-[13px] text-[#4B5563]">Nombre completo</p>
                      <p class="mt-1 mb-0 text-lg font-bold leading-snug break-words">{{ holderName() || '—' }}</p>
                      <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3">
                        <div class="min-w-0">
                          <p class="m-0 text-[13px] text-[#4B5563]">Correo</p>
                          <p class="mt-1 mb-0 text-[15px] normal-case break-all">{{ form.controls.customerEmail.value || '—' }}</p>
                        </div>
                        <div class="min-w-0">
                          <p class="m-0 text-[13px] text-[#4B5563]">Teléfono</p>
                          <p class="mt-1 mb-0 mono text-[15px]">{{ form.controls.customerPhone.value || '—' }}</p>
                        </div>
                      </div>
                    </div>
                    @if (holderIncomplete()) {
                      <p class="field-error mt-2.5">Faltan datos obligatorios del titular (nombre, apellido paterno o correo); no es posible firmar este mandato.</p>
                    }
                    <p class="mt-2.5 mb-0 text-xs leading-normal text-[#4B5563]">
                      Datos registrados por {{ m.merchantName }} al emitir este mandato. En este correo recibirás la copia firmada y el aviso de cada cargo.
                      ¿Algún dato es incorrecto? <span class="underline">Solicita a {{ m.merchantName }} un nuevo mandato</span>.
                    </p>
                  </div>
                </div>
              </section>

              <!-- 02 Objeto y límites -->
              <section class="doc-section doc-pad">
                <h2 class="section-title"><span class="section-num">02</span>Objeto y límites del mandato</h2>
                <div class="overflow-x-auto border border-[#D7DCE3] rounded">
                  <table class="kv sm:min-w-[520px]">
                    <tbody>
                      <tr>
                        <th scope="row">Concepto</th>
                        <td>{{ m.purpose }}</td>
                      </tr>
                      @for (row of limitRows(); track row.key) {
                        <tr>
                          <th scope="row">{{ row.label }}</th>
                          <td>{{ limitValue(row) }}</td>
                        </tr>
                      }
                      <tr>
                        <th scope="row">Vigencia</th>
                        <td>
                          Desde el <strong>{{ (m.validFrom || today) | date:'dd/MM/yyyy' }}</strong>,
                          @if (m.validUntil) {
                            hasta el <strong>{{ m.validUntil | date:'dd/MM/yyyy' }}</strong> o su revocación
                          } @else {
                            por tiempo indefinido hasta su revocación
                          }
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">{{ isVerification() ? 'Cargo de validación (hoy)' : 'Primer cobro (hoy)' }}</th>
                        <td>
                          <span class="mono font-semibold text-lg">{{ m.enrollmentChargeAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} {{ m.currencyCode || 'MXN' }}</span>
                          @if (isVerification()) {
                            <span class="text-[#4B5563]"> · Se cancela de inmediato; podrías ver una retención temporal en tu estado de cuenta.</span>
                          } @else {
                            <span class="text-[#4B5563]"> · {{ m.enrollmentChargeConcept }}</span>
                            @if (m.enrollmentChargeLines?.length) {
                              <ul class="m-0 mt-1 pl-4 text-sm text-[#4B5563]">
                                @for (line of m.enrollmentChargeLines; track $index) {
                                  <li>
                                    {{ line.quantity }} × {{ line.description }} · {{ (line.totalAmount ?? line.unitPrice) | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                                    @if (line.taxAmount) {
                                      (incluye impuestos por {{ line.taxAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }})
                                    }
                                  </li>
                                }
                              </ul>
                            }
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <!-- 03 Cláusulas -->
              <section class="doc-section doc-pad">
                <h2 class="section-title"><span class="section-num">03</span>Cláusulas</h2>
                <ol class="serif m-0 pl-[22px] flex flex-col gap-3.5 text-base leading-[1.6] text-[#1F2937] list-decimal">
                  @for (clause of clauses(); track $index) {
                    <li>
                      {{ clause.text }}
                      @if (clause.items.length) {
                        <ul class="mt-1.5 mb-0 pl-5 list-disc">
                          @for (item of clause.items; track $index) {
                            <li>{{ item }}</li>
                          }
                        </ul>
                      }
                    </li>
                  }
                </ol>
              </section>

              <!-- 04 Medio de pago -->
              <section class="doc-section doc-pad">
                <h2 class="section-title"><span class="section-num">04</span>Medio de pago autorizado</h2>
                @if (savedCards().length) {
                  <div id="mit-saved-cards" class="mb-5 max-w-[640px] rounded border p-4"
                    [class]="cardLimitReached() ? 'border-amber-400 bg-amber-50' : 'border-[#D7DCE3]'">
                    <p class="label-caps mb-1">Tarjetas guardadas con {{ m.merchantName }}</p>
                    <p class="mt-0 mb-3 text-xs text-[#4B5563]">
                      @if (hasSelectableCards()) { Elige una para firmar con ella o captura otra tarjeta. }
                      Puedes eliminar las que ya no uses. Las que están en uso no se pueden eliminar.
                    </p>
                    <ul class="m-0 p-0 list-none divide-y divide-[#E5E7EB]" role="radiogroup" aria-label="Tarjeta para firmar">
                      @for (card of savedCards(); track card.id) {
                        <li class="flex items-center justify-between gap-3 py-2">
                          <label class="flex items-center gap-2 min-w-0" [class.cursor-pointer]="card.selectable"
                            [class.opacity-60]="!card.selectable">
                            <input type="radio" name="mitSavedCard" [value]="card.id" [checked]="selectedCardId() === card.id"
                              [disabled]="!card.selectable || sending()" (change)="selectCard(card)" />
                            <span class="mono text-sm">
                              {{ card.brand || 'Tarjeta' }} •••• {{ card.lastDigits }}
                              <span class="text-[#4B5563]"> · {{ card.expirationMonth }}/{{ card.expirationYear }}</span>
                            </span>
                          </label>
                          @if (card.inUse) {
                            <span class="text-xs text-[#4B5563]">{{ card.currentForMandate ? 'En uso en este mandato' : 'En uso' }}</span>
                          } @else {
                            <button type="button" class="btn-secondary !min-h-0 !py-1.5 !px-3 !text-xs" [disabled]="deletingCardId() != null"
                              (click)="openDeleteCard(card)">
                              Eliminar
                            </button>
                          }
                        </li>
                      }
                      @if (hasSelectableCards()) {
                        <li class="py-2">
                          <label class="flex items-center gap-2 cursor-pointer">
                            <input type="radio" name="mitSavedCard" [checked]="selectedCardId() == null" [disabled]="sending()"
                              (change)="selectCard(null)" />
                            <span class="text-sm">Usar otra tarjeta</span>
                          </label>
                        </li>
                      }
                    </ul>
                  </div>
                }

                @if (selectedCard(); as card) {
                  <p class="m-0 max-w-[640px] text-[15px] text-[#1F2937]">
                    Firmarás con la tarjeta <strong class="mono">{{ card.brand || 'Tarjeta' }} •••• {{ card.lastDigits }}</strong>;
                    no necesitas capturar sus datos.
                  </p>
                } @else {
                <div class="grid grid-cols-3 sm:grid-cols-4 gap-x-4 gap-y-3.5 max-w-[640px]">
                  <label class="field col-span-3 sm:col-span-4">Número de tarjeta *
                    <input type="text" class="mono" formControlName="cardNumber" inputmode="numeric" maxlength="19" autocomplete="cc-number"
                      (input)="onDigits('cardNumber', 19)" placeholder="0000 0000 0000 0000" [class.is-invalid]="invalid('cardNumber')" />
                    @if (invalid('cardNumber')) { <span class="field-error">Ingresa un número de tarjeta válido.</span> }
                  </label>
                  <label class="field">Mes *
                    <input type="text" class="mono" formControlName="expMonth" inputmode="numeric" maxlength="2" autocomplete="cc-exp-month"
                      (input)="onDigits('expMonth', 2)" placeholder="MM" [class.is-invalid]="invalid('expMonth') || cardExpired()" />
                  </label>
                  <label class="field">Año *
                    <input type="text" class="mono" formControlName="expYear" inputmode="numeric" maxlength="2" autocomplete="cc-exp-year"
                      (input)="onDigits('expYear', 2)" placeholder="AA" [class.is-invalid]="invalid('expYear') || cardExpired()" />
                  </label>
                  <label class="field">CVV *
                    <input type="password" class="mono" formControlName="cvv" inputmode="numeric" maxlength="4" autocomplete="cc-csc"
                      (input)="onDigits('cvv', 4)" placeholder="•••" [class.is-invalid]="invalid('cvv')" />
                  </label>
                </div>
                @if (invalid('expMonth') || invalid('expYear') || invalid('cvv')) {
                  <p class="field-error mt-2">Revisa la vigencia (MM / AA) y el CVV (3 o 4 dígitos).</p>
                } @else if (cardExpired()) {
                  <p class="field-error mt-2">La tarjeta está vencida. Usa una tarjeta vigente.</p>
                }
                }
                <p class="mt-3 mb-0 text-xs text-[#4B5563] flex gap-1.5 items-center">
                  <i class="pi pi-shield text-xs" aria-hidden="true"></i>
                  Los datos de la tarjeta se guardan cifrados con el procesador de pagos; {{ m.merchantName }} no los ve.
                </p>
              </section>

              <!-- 05 Aceptación y firma -->
              <section class="doc-pad !pb-10 bg-[#FAFAFB]">
                <h2 class="section-title"><span class="section-num">05</span>Aceptación y firma</h2>
                <div class="grid grid-cols-1 sm:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] gap-x-8 items-end">
                  <label class="field min-w-0">Escribe tu nombre completo para firmar *
                    <input type="text" formControlName="signatureName" maxlength="150" autocomplete="name" placeholder="Nombre y apellidos del titular"
                      [class.is-invalid]="invalid('signatureName')" />
                  </label>
                  <div class="script signature-box min-w-0 h-[72px] mt-6 sm:mt-0 flex items-end px-2 pb-1.5 leading-none text-[#1E3A8A]">
                    <span class="signature-text" [appFitText]="form.controls.signatureName.value">{{ form.controls.signatureName.value || ' ' }}</span>
                  </div>
                  <div class="min-w-0 self-start sm:col-start-2 sm:row-start-2">
                    <div class="signature-line flex justify-between gap-3">
                      <span>Firma electrónica del titular</span>
                      <span class="mono">{{ today | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <p class="mt-2 mb-0 text-xs text-[#4B5563]">Se registrarán fecha, hora, IP y dispositivo como evidencia de la firma.</p>
                  </div>
                  <label class="self-start mt-6 sm:mt-4 sm:col-start-1 sm:row-start-2 flex gap-3 items-start text-sm leading-[1.55] text-[#1F2937] cursor-pointer">
                    <input type="checkbox" formControlName="consentAccepted" class="w-5 h-5 mt-0.5 flex-none accent-[#1B2333]" />
                    <span>
                      He leído el mandato y autorizo a <strong>{{ m.merchantName }}</strong> a cargar a mi tarjeta hasta
                      {{ maxPerCharge() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} por cobro y
                      {{ maxPerMonth() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} por mes, conforme a las cláusulas anteriores.
                    </span>
                  </label>
                </div>

                @if (error()) {
                  <div class="mt-6 rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
                    {{ error() }}
                    @if (attemptsExhausted()) {
                      <span class="block mt-1">Se agotaron los intentos. Pide al comercio una nueva liga.</span>
                    } @else if (result()?.remainingAttempts != null) {
                      <span class="block mt-1">Puedes intentar con otra tarjeta ({{ result()?.remainingAttempts }} intento(s) restante(s)).</span>
                    }
                  </div>
                }

                <div class="mt-8 flex flex-wrap gap-4 items-center justify-between">
                  <button type="submit" class="btn-primary" [disabled]="!canSign()">
                    @if (sending()) {
                      <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Procesando…
                    } @else {
                      <i class="pi pi-pen-to-square" aria-hidden="true"></i>
                      @if (isVerification()) {
                        Firmar mandato y validar tarjeta
                      } @else {
                        Firmar mandato y pagar {{ m.enrollmentChargeAmount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                      }
                    }
                  </button>
                  <p class="m-0 text-xs text-[#4B5563] max-w-[360px]">
                    Al firmar recibirás por correo una copia de este mandato y la liga para revocarlo.
                  </p>
                </div>
              </section>
            </article>
          </form>

          <footer class="mt-4 flex flex-wrap justify-between gap-x-6 gap-y-2 text-xs text-[#4B5563]">
            <span>Mandato {{ m.number }} · Página 1 de 1</span>
            <span>&copy; 2026 Pento &mdash; Todos los derechos reservados</span>
          </footer>
        }
      }

      <!-- ============================== COMPROBANTE ============================== -->
      @case ('receipt') {
        @if (mandate(); as m) {
          @if (signedEmail()) {
            <div class="no-print flex flex-wrap gap-4 items-center mb-5 bg-[#ECFDF5] border border-[#A7F3D0] rounded px-5 py-4">
              <i class="pi pi-check-circle text-2xl text-[#047857]" aria-hidden="true"></i>
              <div class="flex-[1_1_300px] min-w-0">
                <p class="m-0 font-semibold text-[#065F46]">
                  {{ isReplacement() ? 'Tarjeta reemplazada' : 'Mandato firmado' }}
                </p>
                @if (result()?.message) {
                  <p class="mt-0.5 mb-0 text-sm text-[#065F46]">{{ result()?.message }}</p>
                }
                <p class="mt-0.5 mb-0 text-sm text-[#065F46]">Enviamos una copia a {{ signedEmail() }} con la liga para revocarlo.</p>
              </div>
            </div>
          }

          <article class="doc">
            <div class="doc-accent"></div>

            <div class="doc-head doc-pad sm:!pt-10 sm:!pb-7 flex flex-wrap gap-6 justify-between items-start">
              <div class="flex-[1_1_380px] min-w-0">
                <p class="eyebrow mb-2">Comprobante</p>
                <h1 class="serif text-[24px] sm:text-[34px] leading-[1.15] font-bold m-0">Mandato de cargo recurrente a tarjeta</h1>
              </div>
              <div class="stamp flex-none" [class]="'stamp stamp-' + stamp().tone">
                <p class="m-0 text-xl font-bold tracking-[0.14em]">{{ stamp().label }}</p>
                @if (m.signature?.signedAt) {
                  <p class="mt-0.5 mb-0 mono text-xs">{{ m.signature?.signedAt | date:'dd/MM/yyyy HH:mm' }}</p>
                }
              </div>
            </div>

            <section class="doc-section doc-pad !py-7 grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-x-8 gap-y-0">
              <div>
                <p class="label-caps mb-1">Folio</p>
                <p class="m-0 mono text-base font-semibold">{{ m.number }}</p>
              </div>
              <div>
                <p class="label-caps mb-1">Beneficiario</p>
                <p class="m-0 text-base font-semibold">{{ m.merchantLegalName || m.merchantName }}</p>
                @if (m.merchantTaxId) { <p class="m-0 text-xs text-[#4B5563]">RFC {{ m.merchantTaxId }}</p> }
              </div>
              <div>
                <p class="label-caps mb-1">Titular</p>
                <p class="m-0 text-base font-semibold">{{ m.signature?.signerName || m.customerLegalName || m.customerName }}</p>
              </div>
              <div>
                <p class="label-caps mb-1">Tarjeta</p>
                <p class="m-0 mono text-base font-semibold">•••• {{ m.signature?.cardLastDigits || m.currentCardLastDigits }}</p>
              </div>
            </section>

            <section class="doc-section doc-pad !py-7">
              <h2 class="section-title !mb-4">Condiciones autorizadas</h2>
              <div class="overflow-x-auto border border-[#D7DCE3] rounded">
                <table class="kv sm:min-w-[480px]">
                  <tbody>
                    <tr>
                      <th scope="row" class="!py-3">Concepto</th>
                      <td class="!py-3">{{ m.purpose }}</td>
                    </tr>
                    <tr>
                      <th scope="row" class="!py-3">Límites</th>
                      <td class="!py-3 mono">
                        {{ maxPerCharge() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} / cobro ·
                        {{ maxPerMonth() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }} / mes
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" class="!py-3">Vigencia</th>
                      <td class="!py-3">
                        Desde {{ m.validFrom | date:'dd/MM/yyyy' }}, {{ m.validUntil ? 'hasta el ' + (m.validUntil | date:'dd/MM/yyyy') : 'hasta su revocación' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="doc-section doc-pad !py-7">
              <h2 class="section-title !mb-4">Cargos bajo este mandato</h2>
              <div class="border-t border-[#E5E7EB]">
                @for (charge of receiptCharges(); track $index) {
                  <div class="flex flex-wrap gap-x-6 gap-y-3 justify-between items-center py-3.5 border-b border-[#E5E7EB]">
                    <div>
                      <p class="m-0 font-semibold">{{ charge.concept }}{{ charge.initial ? (charge.type === 'CARD_VERIFICATION' ? ' · cargo de validación' : ' · primer cobro') : '' }}</p>
                      <p class="mt-0.5 mb-0 text-[13px] text-[#4B5563]">
                        {{ charge.chargedAt | date:'dd/MM/yyyy' }}@if (charge.reference) { · Autorización {{ charge.reference }} }
                        @if (charge.type === 'CARD_VERIFICATION') {
                          · {{ charge.status === 'VOIDED' ? 'Cancelado' : 'Cancelación en proceso' }}
                        }
                      </p>
                    </div>
                    <p class="m-0 mono text-lg font-semibold">{{ charge.amount | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}</p>
                  </div>
                } @empty {
                  <p class="py-3.5 m-0 text-sm text-[#4B5563] border-b border-[#E5E7EB]">Aún no hay cargos con este mandato.</p>
                }
              </div>
              @if (m.status === 'ACTIVE' || m.status === 'SUSPENDED') {
                <p class="mt-3 mb-0 text-[13px] text-[#4B5563]">
                  Disponible este mes:
                  <strong class="mono text-[#1B2333]">{{ monthAvailable() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}</strong>
                  de {{ maxPerMonth() | currency:(m.currencyCode || 'MXN'):'symbol-narrow' }}
                </p>
              }
            </section>

            <section class="doc-pad !pt-0 !pb-9 flex flex-wrap gap-8 items-end justify-between">
              <div class="flex-[0_1_320px] min-w-0">
                <div class="script signature-box h-16 flex items-end px-2 pb-1.5 leading-none text-[#1E3A8A]">
                  <span class="signature-text" [appFitText]="m.signature?.signerName">{{ m.signature?.signerName || ' ' }}</span>
                </div>
                <div class="signature-line">
                  Firma electrónica · {{ m.signature?.signedAt | date:'dd/MM/yyyy HH:mm' }}@if (m.signature?.ipAddress) { · IP {{ m.signature?.ipAddress }} }
                </div>
              </div>
              <div class="no-print flex flex-wrap gap-3">
                <button type="button" class="btn-secondary btn-dark" (click)="print()">
                  <i class="pi pi-download" aria-hidden="true"></i> Descargar PDF
                </button>
              </div>
              @if (m.status === 'ACTIVE' || m.status === 'SUSPENDED') {
                <p class="no-print mt-3 mb-0 text-xs text-[#4B5563]">
                  Para revocar el mandato o administrar tus tarjetas usa la liga de gestión que te enviamos por correo.
                </p>
              }
            </section>
          </article>

          <footer class="mt-6 flex flex-wrap justify-between gap-x-6 gap-y-2 text-xs text-[#4B5563]">
            <span class="break-all">Mandato {{ m.number }}@if (m.signature?.documentHash) { · Huella del documento <span class="mono">{{ m.signature?.documentHash }}</span> }</span>
            <span>&copy; 2026 Pento &mdash; Todos los derechos reservados</span>
          </footer>
        }
      }
    }
  </main>
}

@if (cardToDelete(); as card) {
  <div class="modal-backdrop no-print" (click)="closeDeleteCard()">
    <div class="doc modal" role="dialog" aria-modal="true" aria-labelledby="mitDeleteCardTitle" (click)="$event.stopPropagation()">
      <div class="doc-accent"></div>
      <div class="p-6 sm:p-8 flex flex-col gap-4">
        <h2 id="mitDeleteCardTitle" class="serif text-[22px] font-bold m-0">¿Eliminar esta tarjeta?</h2>
        <p class="m-0 text-[15px] leading-[1.55] text-[#374151]">
          La tarjeta <strong class="mono">{{ card.brand || 'Tarjeta' }} •••• {{ card.lastDigits }}</strong>
          ya no quedará guardada con {{ mandate()?.merchantName }} y no se podrá usar para sus cargos.
          Esta acción no se puede deshacer.
        </p>
        @if (deleteCardError()) {
          <div class="rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">{{ deleteCardError() }}</div>
        }
        <div class="mt-2 flex flex-wrap justify-end gap-3">
          <button type="button" class="btn-secondary" (click)="closeDeleteCard()" [disabled]="deletingCardId() != null">Cancelar</button>
          <button type="button" class="btn-secondary btn-danger" (click)="deleteSavedCard()" [disabled]="deletingCardId() != null">
            @if (deletingCardId() != null) { <i class="pi pi-spin pi-spinner" aria-hidden="true"></i> Eliminando… } @else { Sí, eliminar }
          </button>
        </div>
      </div>
    </div>
  </div>
}
